module.exports = __webpack_public_path__ + "img/es50_2.3fcfdc35.png";